import type { IconData } from '@stacksjs/iconify-core'

export const deviantart: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12.985 0H8.846L7.141 3.211a1.2 1.2 0 0 1-1.066.631H.033v5.1h3.27c.362 0 .596.373.43.686l-3.7 6.967v3.375h4.131l1.706-3.21a1.2 1.2 0 0 1 1.066-.632h6.049v-5.1H9.707a.47.47 0 0 1-.43-.686l3.708-6.98z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default deviantart
